import type { CSSProperties } from "react";
import { CategoryActionsMenu } from "@/domains/categories/components/CategoryActionsMenu";
import "@/domains/categories/categories.css";

interface TagCardProps {
  name: string;
  description: string;
  amount: string;
  percent: number;
  percentLabel: string;
  color?: string | null;
  actions: { edit: string; view: string; delete: string; menu: string };
  onOpen: () => void;
  onEdit: () => void;
  onDelete: () => void;
}

export const TagCard = ({ name, description, amount, percent, percentLabel, color, actions, onOpen, onEdit, onDelete }: TagCardProps) => {
  const share = Math.min(100, Math.max(0, percent));
  const style = { "--tag-color": color ?? "var(--ds-surface-raised)", "--tag-ink": color ? "var(--ds-on-card)" : "var(--ds-ink)" } as CSSProperties;
  return <article className="tag-card" style={style}>
    <div className="tag-card-top">
      <button type="button" className="tag-card-open app-focus-ring" onClick={onOpen}><span className="tag-card-name">{name}</span><span className="tag-card-description">{description}</span></button>
      <div className="tag-card-side"><span className="tag-card-amount">{amount}</span><CategoryActionsMenu name={name} actions={actions} onEdit={onEdit} onView={onOpen} onDelete={onDelete} /></div>
    </div>
    <div className="tag-card-share"><div className="tag-card-bar" role="progressbar" aria-label={`${name}: ${percentLabel}`} aria-valuemin={0} aria-valuemax={100} aria-valuenow={share} aria-valuetext={`${Math.round(share)}% ${percentLabel}`}><span style={{ width: `${share}%` }} /></div><b>{Math.round(share)}%</b></div>
  </article>;
};
